(() => {
  // app/scripts/predictive-search.js
  var { serializeForm, debounceTime } = theme;
  var PredictiveSearch = class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.input = this.querySelector("[name=q]");
      this.serializeForm = serializeForm;
      this.events?.abort();
      const events = this.events = new AbortController();
      this.addEventListener("input", debounceTime((event) => {
        if (!events.signal.aborted) 
          this.onChange(event);
      }, 300).bind(this), { signal: events.signal });
      this.input.addEventListener("click", this.onFocus.bind(this), { signal: events.signal });
      this.input.addEventListener("focusin", this.onFocus.bind(this), { signal: events.signal });
      this.input.addEventListener("touchstart", this.onFocus.bind(this), { passive: true, signal: events.signal });
      this.addEventListener("focusout", this.onFocusOut.bind(this), { signal: events.signal });
      this.addEventListener("keyup", this.onKeyup.bind(this), { signal: events.signal });
      this.providerObserver?.disconnect();
      this.providerObserver = new MutationObserver(() => this.suppressNativeSearch());
      this.providerObserver.observe(this.input, { attributes: true, attributeFilter: ["class"] });
      this.suppressNativeSearch();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.providerObserver?.disconnect();
      this.close();
    }
    cancelRequest() {
      this.requestVersion = (this.requestVersion || 0) + 1;
      this.requestController?.abort();
      this.requestController = null;
    }
    suppressNativeSearch() {
      if (!this.input.classList.contains("snize-input-style"))
        return false;
      this.close();
      const results = this.querySelector(".js-search-result");
      const restoreInputFocus = results?.contains(document.activeElement);
      if (results?.childNodes.length)
        results.replaceChildren();
      if (restoreInputFocus)
        this.input.focus({ preventScroll: true });
      return true;
    }
    onChange(e) {
      if (!this.isConnected || this.suppressNativeSearch())
        return;
      const key = e.target.value.trim();
      if (!key.length) {
        this.close();
        return;
      }
      this.getRequest(key);
    }
    async getRequest(key, recommend) {
      if (!this.isConnected || this.suppressNativeSearch())
        return;
      this.cancelRequest();
      const version = this.requestVersion;
      const controller = this.requestController = new AbortController();
      this.searchQuery = JSON.parse(this.serializeForm(this.form));
      this.searchQuery.q = key;
      this.searchQuery.section_id = this.dataset.section;
      this.classList.add("is-searching");
      const query = new URLSearchParams(this.searchQuery).toString();
      const url = this.dataset.url + "?" + query;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok)
          throw new Error("Predictive search unavailable");
        const html = await response.text();
        if (version !== this.requestVersion || !this.isConnected || this.suppressNativeSearch())
          return;
        const results = html.split("<!-- /// -->")[1];
        if (results === undefined)
          throw new Error("Predictive search results unavailable");
        this.querySelector(".js-search-result").innerHTML = results;
        this.open();
      } catch (error) {
        if (version === this.requestVersion)
          this.close();
      } finally {
        if (version === this.requestVersion) {
          this.classList.remove("is-searching");
          this.requestController = null;
        }
      }
    }
    focusSearch() {
      this.input.focus();
    }
    open() {
      if (this.suppressNativeSearch())
        return;
      this.classList.add("show");
    }
    close() {
      this.cancelRequest();
      this.classList.remove("show", "is-searching");
    }
    onFocus() {
      this.open();
    }
    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement))
          this.close();
      });
    }
    onKeyup(event) {
      if (this.suppressNativeSearch())
        return;
      if (event.code == "Escape")
        this.close();
    }
  };
  customElements.define("predictive-search", PredictiveSearch);
})();
